<angular-multiselect [data]="itemList" [(ngModel)]="selectedItems" [settings]="settings" (onSelect)="onItemSelect($event)"
(onDeSelect)="OnItemDeSelect($event)" (onClose)="onClose()" (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)">
<c-search>
     <ng-template>
         <input type="text" [(ngModel)]="filter" (keyup)="onSearch($event)" placeholder="Search countries" style="border: none;width: 100%; height: 100%;outline: none;"/>
     </ng-template>
</c-search>
<c-item>
    <ng-template let-item="item">
        <label style="color: #333;width: 150px;">{{item.name}}</label>
        <img [src]="item.flag" style="width: 30px; border: 1px solid #efefef;margin-right: 0px;" />
        <label>{{item.capital}}</label>
    </ng-template>
</c-item>
</angular-multiselect>